import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import CottSvg from "../assets/images/svg/cott-svg.svg";
import RatingStar from "../assets/images/svg/rating-star.svg";

const ClientsSaySlider = () => {
    return (
        <>
            {/* <!-- ====================================== Section Nine ===================================== --> */}
            <section className="section-nine">
                <div className="container">
                    <div className="section-nine-bg position-relative">
                        <h2
                            className="section-heading-text latestProjects-heading"
                            data-aos="fade-up"
                        >
                            O que <span>Os Clientes</span> Dizem
                        </h2>

                        <p
                            className="section-sub-text pharetra urna"
                            data-aos="fade-up"
                        >
                            A chegada da instituição ao estado representou um desafio: ofertar cursos na modalidade 
                            semipresencial na área da saúde, levando qualidade e inovação à formação de novos 
                            profissionais.
                        </p>

                        <div className="swiper-wrapper clientSaySwiper-wrapper">
                            <Swiper
                                className="clientSaySwiper"
                                slidesPerView={3}
                                spaceBetween={30}
                                loop={true}
                                speed={1600}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }}
                                pagination={{
                                    el: '.swiper-pagination',
                                    clickable: true,
                                }}
                                breakpoints={{
                                    991: {
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                    },
                                    767: {
                                        slidesPerView: 2,
                                        spaceBetween: 20,
                                    },
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 12,
                                        centeredSlides: true,
                                    },
                                }}
                                modules={[Pagination, Autoplay]}
                            >
                                <SwiperSlide>
                                    <div className="swiper-slide clientSaySwiper-slide">
                                        <img src={RatingStar} alt="rating-star" />
                                        <h3 className="great">Mais clareza para decidir</h3>
                                        <p className="nisl">
                                            Eu cheguei com muitas dúvidas e uma sensação de estar
                                            travada. Nas conversas com o Philippe consegui organizar
                                            o que realmente era importante, entender minhas opções e
                                            dar passos concretos, sem me sentir pressionada ou julgada.
                                            Foi um espaço seguro para pensar a minha vida com calma.
                                        </p>
                                        <div className="cotte-main">
                                            <div>
                                                <h4 className="great Tom">Marina S.</h4>
                                                <p className="nisl client-date">15 jan 2025</p>
                                            </div>
                                            <img src={CottSvg} alt="cott-svg" />
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="swiper-slide clientSaySwiper-slide">
                                        <img src={RatingStar} alt="rating-star" />
                                        <h3 className="great">Acompanhamento humano e direto</h3>
                                        <p className="nisl">
                                            O que mais me chamou atenção foi a forma simples e direta
                                            com que o Philippe conduz as conversas. Nada de frases prontas:
                                            ele realmente escuta, questiona e ajuda a enxergar o que eu não
                                            estava vendo. Saio de cada encontro com mais consciência e
                                            com ações práticas para o dia a dia.
                                        </p>
                                        <div className="cotte-main">
                                            <div>
                                                <h4 className="great Tom">André L.</h4>
                                                <p className="nisl client-date">08 dez2025</p>
                                            </div>
                                            <img src={CottSvg} alt="cott-svg" />
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="swiper-slide clientSaySwiper-slide">
                                        <img src={RatingStar} alt="rating-star" />
                                        <h3 className="great">Me ajudou a sair do automático</h3>
                                        <p className="nisl">
                                            Eu estava no piloto automático há anos, repetindo decisões
                                            que não faziam mais sentido. Com o apoio do Philippe,
                                            consegui olhar para a minha rotina, rever prioridades e
                                            escolher caminhos mais alinhados com o que eu realmente
                                            quero. Não foi fácil, mas foi muito mais leve com alguém
                                            caminhando junto.
                                        </p>
                                        <div className="cotte-main">
                                            <div>
                                                <h4 className="great Tom">Carolina M.</h4>
                                                <p className="nisl client-date">21 nov2025</p>
                                            </div>
                                            <img src={CottSvg} alt="cott-svg" />
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="swiper-slide clientSaySwiper-slide">
                                        <img src={RatingStar} alt="rating-star" />
                                        <h3 className="great">Segurança para mudar de direção</h3>
                                        <p className="nisl">
                                            Eu procurava alguém que não decidisse por mim, mas que me
                                            ajudasse a enxergar os riscos e possibilidades de uma mudança
                                            grande na carreira. O Philippe fez exatamente isso: trouxe
                                            perguntas, contexto e realidade. Hoje me sinto muito mais
                                            seguro com as escolhas que fiz.
                                        </p>
                                        <div className="cotte-main">
                                            <div>
                                                <h4 className="great Tom">Rafael P.</h4>
                                                <p className="nisl client-date">03 out2025</p>
                                            </div>
                                            <img src={CottSvg} alt="cott-svg" />
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>

                            <div className="swiper-pagination btn-pagination"></div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ClientsSaySlider
